import './ReportPageHeader.scss';

import { Typography } from '@trackman/web-shared-components';
import {
  PitchType,
  PitchTypeGroup,
  PlayerHandedness,
  StrikeZoneDisplay,
  UmpireCall,
  UmpireCallCorrectness,
} from 'types/CodegenReportTypes';

import ReportPageHeader from './ReportPageHeader';
import UmpireConditions from './UmpireConditions';
import { useTranslation } from 'react-i18next';

type Props = {
  umpireName?: string;
  sessionName?: string;
  pitchTypes?: PitchType[];
  pitchTypeGroups?: PitchTypeGroup[];
  pitcherHandedness: PlayerHandedness;
  batterHandedness: PlayerHandedness;
  zoneViewMode: StrikeZoneDisplay;
  callCorrectness: UmpireCallCorrectness[];
  umpireCall: UmpireCall;
};

const UmpireSingleSessionHeader = ({
  umpireName,
  sessionName,
  pitchTypes,
  pitchTypeGroups,
  pitcherHandedness,
  batterHandedness,
  zoneViewMode,
  callCorrectness,
  umpireCall,
}: Props) => {
  const { t } = useTranslation();
  return (
    <>
      <ReportPageHeader>
        <Typography key={'umpireName'} variant='h2' component='div' color='#414141'>
          {umpireName ?? t('Umpire’s name')}
        </Typography>
        <Typography variant='body' component='div' color='#414141'>
          |
        </Typography>
        <Typography key={'sessionName'} variant='body' component='div' color='#414141'>
          {sessionName ?? t('Session name')}
        </Typography>
      </ReportPageHeader>
      <UmpireConditions
        pitchTypes={pitchTypes}
        pitchTypeGroups={pitchTypeGroups}
        pitcherHandedness={pitcherHandedness}
        batterHandedness={batterHandedness}
        zoneViewMode={zoneViewMode}
        callCorrectness={callCorrectness}
        umpireCall={umpireCall}
      />
    </>
  );
};

export default UmpireSingleSessionHeader;
